import {SpinePlayer} from "../../core/displayobject/SpinePlayer";
import {LayoutDimData} from "../../core/utils/ResizeHelper";
import {PREngineManager} from "../punkEngine/PREngineManager";
import {gsap} from "gsap";
import {GameConfig} from "../config/base/GameConfig";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class Foreground extends PIXI.Container {

    private readonly _item: SpinePlayer;
    private _bottomTrainVisible: boolean = false;

    constructor() {
        super();
        this.name = "Foreground";

        this._item = new SpinePlayer("foreground");
        this._item.position.set(360);
        this.addChild(this._item);

        this.onResize();
    }

    // #365
    public playForegroundAnimation(animName: string) : void {
        this._item.play({
            animation: animName,
            loop: true
        });
    }

    public onBottomTrainShow(flag: boolean, isRestore: boolean = false): void {
        this._bottomTrainVisible = flag;
        const scaledReelDim: LayoutDimData = this._bottomTrainVisible ? PREngineManager.dimScaled : PREngineManager.dim;

        if (flag) {
            gsap.to(this._item.position, {
                y: (scaledReelDim.scale.x === 0.91 && scaledReelDim.scale.y === 0.91) ? 330 : 360,
                duration: isRestore ? 0.001 : GameConfig.FRAME_EXPAND_DUR
            });
            gsap.to(this._item.scale, {
                x: scaledReelDim.scale.x,
                y: scaledReelDim.scale.y,
                duration: isRestore ? 0.001 : GameConfig.FRAME_EXPAND_DUR
            });
        } else {
            this._item.position.set(360);
            this._item.scale.set(scaledReelDim.scale.x, scaledReelDim.scale.y);
        }
    }

    public onResize(): void {
        const scaledReelDim: LayoutDimData = this._bottomTrainVisible ? PREngineManager.dimScaled: PREngineManager.dim;

        if(NolimitApplication.isLandscape && this._bottomTrainVisible) {
            this._item.y = 330;
        }else{
            this._item.y = 360;
        }
        this._item.scale.set(scaledReelDim.scale.x, scaledReelDim.scale.y);
    }
}